import { faStar, faStarHalfAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useMemo, useState } from "react"; // Added useMemo
import { useDispatch, useSelector } from "react-redux";
import { fetch_all_Reviews, reviewSelector } from "../../api/userReview";

const DriverRatings = () => {
  const dispatch = useDispatch();
  const { reviews } = useSelector(reviewSelector);
  //const driver = localStorage.getItem("driverid")?.toString() || localStorage.getItem("Driver")?.toString(); // Ensure it's a string
  const driver = localStorage.getItem("driverid")?.toString() || localStorage.getItem("Driver"); // Ensure it's a string
  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);
  const [categoryRatings, setCategoryRatings] = useState([]);

  useEffect(() => {
    dispatch(fetch_all_Reviews());
  }, [dispatch]);

  // Memoized filtered reviews
  const filteredReviews = useMemo(() => {
    return (
      reviews?.filter(
        (review) => review.rideId?.driverId?.toString() === driver
      ) || []
    );
  }, [reviews, driver]);

  useEffect(() => {
    if (filteredReviews.length > 0) {
      // Calculate overall rating
      const totalStars = filteredReviews.reduce(
        (sum, review) => sum + (review.stars ?? 0), // Default to 0 if stars are missing
        0
      );
      const avgRating = totalStars / filteredReviews.length;
      setAverageRating(avgRating);
      setTotalReviews(filteredReviews.length);

      // Calculate category ratings
      const categoryKeys = [
        "drivingSafety",
        "vehicleCondition",
        "punctuality",
        "customerService",
      ];
      const categoryLabels = {
        drivingSafety: "Driving Safety",
        vehicleCondition: "Vehicle Condition",
        punctuality: "Punctuality",
        customerService: "Customer Service",
      };

      const calculatedCategories = categoryKeys.map((key) => {
        const total = filteredReviews.reduce(
          (sum, review) => sum + (review[key] ?? 0), // Default to 0 if missing
          0
        );
        const average = total / filteredReviews.length;
        return {
          category: categoryLabels[key],
          ratingValue: average.toFixed(1),
          percentage: `${Math.round((average / 5) * 100)}%`,
        };
      });

      setCategoryRatings(calculatedCategories);
    } else {
      setAverageRating(0);
      setTotalReviews(0);
      setCategoryRatings([]);
    }
  }, [filteredReviews]);

  // Function to render stars
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="flex">
        {Array(fullStars)
          .fill()
          .map((_, index) => (
            <FontAwesomeIcon key={index} icon={faStar} className="text-yellow-400" />
          ))}
        {hasHalfStar && <FontAwesomeIcon icon={faStarHalfAlt} className="text-yellow-400" />}
        {Array(emptyStars)
          .fill()
          .map((_, index) => (
            <FontAwesomeIcon key={index} icon={faStar} className="text-gray-300" />
          ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4 mt-24">
      {console.log(filteredReviews)}
      <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Driver Ratings</h1>
          <p className="text-gray-600">Overall performance summary</p>
        </div>

        {/* Overall Rating */}
        <div className="flex flex-col items-center mb-10">
          <div className="w-32 h-32 bg-blue-500 rounded-full flex items-center justify-center mb-6">
            <span className="text-white text-4xl font-bold">
              {averageRating.toFixed(1)}
            </span>
          </div>
          <div className="flex gap-2 mb-4">{renderStars(averageRating)}</div>
          <p className="text-gray-600">
            Based on {totalReviews} review{totalReviews !== 1 && "s"}
          </p>
        </div>

        {/* Rating Details */}
        {/* <div className="space-y-6">
          {categoryRatings.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between bg-gray-50 p-4 rounded-lg"
            >
              <span className="font-medium text-gray-700">{item.category}</span>
              <div className="flex items-center gap-6">
                <div className="w-48 h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-blue-500 rounded-full transition-all duration-500"
                    style={{ width: item.percentage }}
                  />
                </div>
                <span className="text-gray-700 font-bold w-12">
                  {item.ratingValue}
                </span>
              </div>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default DriverRatings;
